// Local copy of the suite's JWT reader (ADR 0001: services duplicate rather than
// share runtime code). Decoding only — never verification: the token is proof to
// the API, and this app reads it purely to greet the signed-in person by address.
export type JwtPayload = {
  userId?: string;
  email?: string;
  exp?: number;
  iat?: number;
  [k: string]: unknown;
};

function base64UrlDecode(input: string): string {
  const pad = '='.repeat((4 - (input.length % 4)) % 4);
  const base64 = (input + pad).replace(/-/g, '+').replace(/_/g, '/');
  const decoded = atob(base64);
  try {
    return decodeURIComponent(
      decoded
        .split('')
        .map((c) => `%${c.charCodeAt(0).toString(16).padStart(2, '0')}`)
        .join(''),
    );
  } catch {
    return decoded;
  }
}

export function decodeJwt(token: string): JwtPayload | null {
  const parts = token.split('.');
  if (parts.length < 2) return null;
  try {
    return JSON.parse(base64UrlDecode(parts[1])) as JwtPayload;
  } catch {
    return null;
  }
}
